import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { GiSoccerBall, GiStrikingArrows } from "react-icons/gi";
import bettingService from "../../../api/services/bettingService";

const SelectedMatchesCard = ({ match, expand,showHideDetails }) => {
  const { t } = useTranslation();
  const language = localStorage.getItem("language");
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setData(null);
    if (match.gamblingTypeId === 1) {
      const fetchData = async () => {
        try {
          setIsLoading(true);
          const response = await bettingService.bettingHistoryDetails({
            gamblingId: Number(match.gamblingId),
            status: "Inplay",
          });
          const res = await response.json();
          if (res && res.length > 0) setData({ ...match, ...res[0] });
        } catch (err) {
          if (err?.response?.status === 401) navigate("/login");
          else console.error("API request error:", err);
        } finally {
          setIsLoading(false);
        }
      };
      fetchData();
    }
  }, [match, navigate]);

  const renderIcon = () =>
    match?.gamblingTypeId === 1 ? (
      <div className="w-8 h-8 bg-[#228B22] rounded-full flex items-center justify-center">
        <GiSoccerBall size={18} className="text-white" />
      </div>
    ) : (
      <div className="w-8 h-8 bg-[#FFD700] rounded-full flex items-center justify-center">
        <GiStrikingArrows size={18} className="text-gray-900" />
      </div>
    );

    return (
        <div
          onClick={() => showHideDetails(match.id)}
          className="relative bg-white/80 backdrop-blur-sm rounded-2xl p-3 border border-[#228B22]/20 shadow-lg hover:shadow-xl transition-all duration-200 cursor-pointer font-myanmarSansPro overflow-hidden"
        >
          {/* Background Pattern */}
          <div className="absolute inset-0 bg-gradient-to-br from-[#228B22]/5 to-emerald-500/5 rounded-2xl"></div>

          {/* Header */}
          <div className="relative flex justify-between items-center mb-2">
            <div className="flex items-center gap-3">
              {renderIcon()}
              <div>
                <h2 className="text-[#228B22] font-bold text-lg">
                  {match?.gamblingTypeId === 1 ? t("body") : t("maungg")}
                </h2>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-[#FFD700] rounded-full mr-2"></div>
                  <span className="text-xs text-gray-600 font-medium">Match History</span>
                </div>
              </div>
            </div>
            <div className="text-right">
              <p className="text-xs text-gray-500 font-dangrek">
                {moment(match?.createdDate).format("DD-MM-YYYY")}
              </p>
              <p className="text-xs text-gray-500 font-dangrek">
                {moment(match?.createdDate).format("hh:mm A")}
              </p>
            </div>
          </div>

          {/* Basic Info */}
          <div className="relative bg-white/70 rounded-xl px-4 py-2 space-y-1 border border-[#228B22]/10">
            <div className="flex justify-between items-center">
              <span className="font-semibold text-gray-700 flex items-center">
                <span className="w-2 h-2 bg-[#228B22] rounded-full mr-2"></span>
                {t("BetID")}:
              </span>
              <span className="font-dangrek font-bold text-[#228B22]">{match?.postingNo}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="font-semibold text-gray-700 flex items-center">
                <span className="w-2 h-2 bg-[#FFD700] rounded-full mr-2"></span>
                {t("betAmount")}:
              </span>
              <span className="font-dangrek font-bold text-[#1E90FF]">{parseInt(match?.amount).toLocaleString()}</span>
            </div>
            {match?.gamblingTypeId === 2 && (
              <div className="flex justify-between items-center">
                <span className="font-semibold text-gray-700 flex items-center">
                  <span className="w-2 h-2 bg-[#FF4500] rounded-full mr-2"></span>
                  {t("teamCount")}:
                </span>
                <span className="font-dangrek font-bold text-gray-900">{match?.teamCount}</span>
              </div>
            )}
          </div>

          {/* Match Status */}
          {match?.status === "Inplay" && (
            <div className="relative mt-2 flex justify-end">
              <div className="inline-flex items-center bg-gradient-to-r from-green-500 to-emerald-600 px-3 py-2 rounded-full">
                <div className="w-2 h-2 bg-white rounded-full mr-2 animate-pulse"></div>
                <span className="text-white text-xs font-bold">{t("ongoing")}</span>
              </div>
            </div>
          )}

          {/* Loading Indicator */}
          {isLoading && (
            <div className="relative mt-4">
              <div className="h-2 w-full bg-gray-200 rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-[#228B22] to-emerald-600 rounded-full animate-pulse" style={{ width: '60%' }}></div>
              </div>
              <p className="text-xs text-gray-500 mt-1 text-center">Loading match details...</p>
            </div>
          )}

          {/* Decorative Elements */}
          <div className="absolute -top-1 -right-1 w-4 h-4 bg-gradient-to-r from-[#FFD700] to-yellow-400 rounded-full shadow-lg animate-pulse"></div>
          <div className="absolute -bottom-1 -left-1 w-3 h-3 bg-gradient-to-r from-[#228B22] to-emerald-600 rounded-full shadow-lg animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>
      );
      
};

export default SelectedMatchesCard;
